<template>
  <modal
    ref="addEnergetic"
    :ok-disabled="loading || saving"
    :ok-title="!$parent.edit ? 'Pridať' : 'Upraviť'"
    :title="
      !$parent.edit
        ? 'Pridať odberné miesto - ELEKTRINA'
        : 'Upraviť odberné miesto - ELEKTRINA'
    "
    cancel-title="Zrušiť"
    full-height
    name="add-energetic"
    scrollable
    size="lg"
    type="from-right"
    @hidden="Object.assign($data, $options.data())"
    @ok="$parent.saveEnergetic"
    @show="fetchData"
  >
    <b-overlay :blur="null" :show="loading" class="h-100" opacity="0">
      <transition mode="out-in" name="fadeShort">
        <div v-if="!loading" ref="scroll" v-bar>
          <div>
            <b-row>
              <b-col md="6">
                <h4>Technické údaje</h4>
                <b-form-group label="EIC kód" label-for="powerNumber">
                  <b-form-input
                    v-model="form.powerNumber"
                    v-validate="'required'"
                    :class="{ 'is-invalid': errors.has('powerNumber') }"
                    data-vv-as="EIC kód"
                    name="powerNumber"
                  />

                  <b-form-invalid-feedback>
                    {{ errors.first('powerNumber') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                  label="Distribučné územie"
                  label-for="distributionAreaID"
                >
                  <b-form-select
                    v-model="form.distributionAreaID"
                    v-validate="'required'"
                    :class="{ 'is-invalid': errors.has('distributionAreaID') }"
                    :select-size="1"
                    data-vv-as="Distribučné územie"
                    name="distributionAreaID"
                  >
                    <option :value="null">--Nedefinované--</option>
                    <option
                      v-for="item in attributes.distributionArea"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </b-form-select>
                  <b-form-invalid-feedback>
                    {{ errors.first('distributionAreaID') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                  label="Miestna distribučná sústava"
                  label-for="distributionArea2ID"
                >
                  <b-form-checkbox
                    v-model="dist"
                    @change="
                      (val) => (!val ? (form.distributionArea2ID = null) : '')
                    "
                  />
                  <b-form-select
                    v-if="dist"
                    v-model="form.distributionArea2ID"
                    v-validate="'required'"
                    :class="{ 'is-invalid': errors.has('distributionArea2ID') }"
                    :select-size="1"
                    data-vv-as="Miestna distribučná sústava"
                    name="distributionArea2ID"
                  >
                    <option :value="null">--Nedefinované--</option>
                    <option
                      v-for="item in attributes.distributionArea2"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </b-form-select>
                </b-form-group>
                <b-form-group
                  label="Napäťová úroveň"
                  label-for="voltageVolumeID"
                >
                  <b-form-select
                    v-model="form.voltageVolumeID"
                    v-validate="'required'"
                    :class="{ 'is-invalid': errors.has('voltageVolumeID') }"
                    :select-size="1"
                    data-vv-as="Napäťová úroveň"
                    name="voltageVolumeID"
                  >
                    <option :value="null">--Nedefinované--</option>
                    <option
                      v-for="item in attributes.voltageVolume"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </b-form-select>
                  <b-form-invalid-feedback>
                    {{ errors.first('voltageVolumeID') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="Distrib. sadzba" label-for="tariffID">
                  <b-form-select
                    v-model="form.tariffID"
                    v-validate="'required'"
                    :class="{ 'is-invalid': errors.has('tariffID') }"
                    :select-size="1"
                    data-vv-as="Distrib. sadzba"
                    name="tariffID"
                  >
                    <option :value="null">--Nedefinované--</option>
                    <option
                      v-for="item in attributes.tariff"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </b-form-select>
                  <b-form-invalid-feedback>
                    {{ errors.first('tariffID') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="Typ merania" label-for="measureTypeID">
                  <b-form-select
                    v-model="form.measureTypeID"
                    v-validate="'required'"
                    :class="{ 'is-invalid': errors.has('measureTypeID') }"
                    :select-size="1"
                    data-vv-as="Typ merania"
                    name="measureTypeID"
                  >
                    <option :value="null">--Nedefinované--</option>
                    <option
                      v-for="item in attributes.measureType"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </b-form-select>
                  <b-form-invalid-feedback>
                    {{ errors.first('measureTypeID') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                  label="Dátum zmeny typu merania"
                  label-for="measureTypeChangeDate"
                >
                  <single-date
                    v-model="form.measureTypeChangeDate"
                    class="form-control"
                    name="measureTypeChangeDate"
                  />
                </b-form-group>
                <b-form-group label="TDO" label-for="tdoID">
                  <b-form-select
                    v-model="form.tdoID"
                    :select-size="1"
                    name="tdoID"
                  >
                    <option :value="null">--Nedefinované--</option>
                    <option
                      v-for="item in attributes.tdo"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </b-form-select>
                </b-form-group>
                <hr />
                <h4>Zmluvný vzťah</h4>
                <b-form-group
                  label="Výpoveď podáme za Vás"
                  label-for="cancellationID"
                >
                  <b-form-select
                    v-model="form.cancellationID"
                    :select-size="1"
                    name="cancellationID"
                  >
                    <option :value="null">--Nedefinované--</option>
                    <option
                      v-for="item in attributes.cancellation"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </b-form-select>
                </b-form-group>
                <b-form-group
                  label="Stav výpovede"
                  label-for="cancellationStateID"
                >
                  <b-form-select
                    v-model="form.cancellationStateID"
                    :select-size="1"
                    name="cancellationStateID"
                  >
                    <option :value="null">--Nedefinované--</option>
                    <option
                      v-for="item in attributes.cancellationState"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </b-form-select>
                </b-form-group>
                <b-form-group
                  label="Zmluva uzatvorená"
                  label-for="agreementTermID"
                >
                  <b-form-select
                    v-model="form.agreementTermID"
                    :select-size="1"
                    name="agreementTermID"
                  >
                    <option :value="null">--Nedefinované--</option>
                    <option
                      v-for="item in attributes.agreementTerm"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </b-form-select>
                </b-form-group>
                <b-form-group
                  label="Zmluva končí dňa"
                  label-for="agreementEndDate"
                >
                  <single-date
                    v-model="form.agreementEndDate"
                    class="form-control"
                    name="agreementEndDate"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <h4>Adresa OM</h4>
                <b-form-group label="Ulica" label-for="street">
                  <b-form-input v-model="form.street" name="street" />
                </b-form-group>
                <b-form-group label="Číslo" label-for="streetNumber">
                  <b-form-input
                    v-model="form.streetNumber"
                    name="streetNumber"
                  />
                </b-form-group>
                <b-form-group label="Súp. číslo" label-for="streetRegNumber">
                  <b-form-input
                    v-model="form.streetRegNumber"
                    name="streetRegNumber"
                  />
                </b-form-group>
                <b-form-group label="Mesto" label-for="city">
                  <b-form-input v-model="form.city" name="city" />
                </b-form-group>
                <b-form-group label="PSČ" label-for="postCode">
                  <b-form-input v-model="form.postCode" name="postCode" />
                </b-form-group>
                <b-form-group label="Lokalita objektu" label-for="locality">
                  <b-form-input v-model="form.locality" name="locality" />
                </b-form-group>
                <b-form-group label="Názov objektu" label-for="localityName">
                  <b-form-input
                    v-model="form.localityName"
                    name="localityName"
                  />
                </b-form-group>
                <b-form-group label="Súradnice" label-for="coordinates">
                  <b-form-input v-model="form.coordinates" name="coordinates" />
                </b-form-group>
                <hr />
                <h4>Obchod</h4>
                <b-form-group
                  label="Dátum registrácie"
                  label-for="registrationDate"
                >
                  <single-date
                    v-model="form.registrationDate"
                    class="form-control"
                    name="registrationDate"
                  />
                </b-form-group>
                <hr />
                <h4>Distribúcia</h4>
                <b-form-group
                  label="Dátum zač. odberu"
                  label-for="consumptionDateStart"
                >
                  <single-date
                    v-model="form.consumptionDateStart"
                    class="form-control"
                    name="consumptionDateStart"
                  />
                </b-form-group>
                <b-form-group
                  label="Spôsob evidencie"
                  label-for="evidenceTypeID"
                >
                  <b-form-select
                    v-model="form.evidenceTypeID"
                    :select-size="1"
                    name="evidenceTypeID"
                  >
                    <option :value="null">--Nedefinované--</option>
                    <option
                      v-for="item in attributes.evidenceType"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </b-form-select>
                </b-form-group>
                <b-form-group label="Číslo OP" label-for="identityNumber">
                  <b-form-input
                    v-model="form.identityNumber"
                    name="identityNumber"
                  />
                </b-form-group>
                <b-form-group label="Číslo zmluvy" label-for="contractNumber">
                  <b-form-input
                    v-model="form.contractNumber"
                    name="contractNumber"
                  />
                </b-form-group>
                <b-form-group label="DP Login" label-for="disporLogin">
                  <b-form-input v-model="form.disporLogin" name="disporLogin" />
                </b-form-group>
                <b-form-group label="DP Heslo" label-for="disporPass">
                  <b-form-input v-model="form.disporPass" name="disporPass" />
                </b-form-group>
                <b-form-group
                  label="Dátum konca odberu"
                  label-for="consumptionDateEnd"
                >
                  <single-date
                    v-model="form.consumptionDateEnd"
                    class="form-control"
                    name="consumptionDateEnd"
                  />
                </b-form-group>
                <b-form-group
                  label="Spôsob ukončenia"
                  label-for="endpointTypeID"
                >
                  <b-form-select
                    v-model="form.endpointTypeID"
                    :select-size="1"
                    name="endpointTypeID"
                  >
                    <option :value="null">--Nedefinované--</option>
                    <option
                      v-for="item in attributes.endpointType"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </div>
      </transition>
    </b-overlay>
  </modal>
</template>
<script>
import Modal from '@/components/Modal'
import SingleDate from '@/components/inputs/SingleDate'

export default {
  components: {
    Modal,
    SingleDate,
  },
  data() {
    return {
      loading: false,
      saving: false,
      attributes: [],
      form: {},
      dist: false,
    }
  },
  methods: {
    fetchData() {
      this.form = {
        customer_id: parseInt(this.$route.params.id),
        typeID: 1,
      }
      if (this.$parent.edit) {
        this.loading = true
      }
      this.axios
        .all([
          this.$api.get('attributes/get', {
            params: {
              select: 'energetics',
              filter: { typeID: 1 },
            },
          }),
          this.$parent.edit
            ? this.$api.get(
                `energetics/${this.$route.params.energetics_id}/get_form`,
              )
            : '',
        ])
        .then(
          this.axios.spread((attrs, formdata) => {
            this.attributes = attrs.data
            if (this.$parent.edit) {
              this.form = formdata.data.data
            }
            if (this.form.distributionArea2ID) {
              this.dist = true
            }
            this.loading = false
          }),
        )
    },
  },
}
</script>
